import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";
import AddFollowup from "./AddFollowup";
import { formatDateTime } from "common/constants/functions";

const LeadDetails = () => {
  const { id } = useParams();
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const [lead, setLead] = useState({});
  const [followups, setFollowups] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => {
    setIsOpen(false);
  };
  const getLead = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getSingleLead",
        leadId: id,
        companyId,
      });
      if (data?.success) {
        setLead(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getLead();
  }, []);
  useEffect(() => {
    setFollowups(lead?.lead_followups);
  }, [lead]);
  return (
    <>
      <section>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="page-title">Lead Details</h4>
          <button type="button" className="btn btn-dark">
            <i className="bi bi-building-check me-2"></i> Matching Affiliates{" "}
            <span className="badge bg-light text-dark">32</span>
          </button>
        </div>
        <div className="card">
          <h5>
            {lead?.firstName} {lead?.lastName}
          </h5>

          <p className="text-muted">
            {lead?.email || "-"} | {lead?.phone}
          </p>
          <div className="property-features">
            <span>For {lead?.sale_type}</span>
            <span>{lead?.property_type_name}</span>
            <span>{lead?.property_subtype_name}</span>
          </div>
          <div className="card mt-3 bg-light border">
            <div className="row gy-3">
              <div className="col-lg-3 col-md-4 col-6">
                <span className="text-muted">Score</span>
                <p className="fw-medium mb-0">{lead?.score}%</p>
              </div>
              <div className="col-lg-3 col-md-4 col-6">
                <span className="text-muted">Source</span>
                <p className="fw-medium mb-0">{lead?.source}</p>
              </div>
              <div className="col-lg-3 col-md-4 col-6">
                <span className="text-muted">Assignee</span>
                <p className="fw-medium mb-0">{lead?.assignee || "-"}</p>
              </div>
              <div className="col-lg-3 col-md-4 col-6">
                <span className="text-muted">Lead Type</span>
                <p className="fw-medium mb-0">{lead?.status}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card mt-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6>FOLLOW-UP NOTES</h6>
            <button type="button" className="btn btn-dark" onClick={() => setIsOpen(true)}>
              <i className="bi bi-plus-lg me-2"></i>Add
            </button>
          </div>
          <ul>
            {followups?.reverse()?.map((l) => (
              <li key={l?.id} className="d-flex align-items-center mb-3">
                <i className="bi bi-check-circle-fill text-success fs-20 me-2"></i>
                <div>
                  {formatDateTime(l?.schedule)}
                  <p className="fw-medium mb-0">{l?.followup}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <AddFollowup {...{ onClose, isOpen, setFollowups, leadId: id }} />
    </>
  );
};

export default LeadDetails;
